/// <reference types="./adminSampleEntities.d.ts" />
import { ok, } from '@dossierhq/core';
import { decodeAdminEntity } from '../EntityCodec.js';
import { sharedSampleEntities } from '../shared-entity/sharedSampleEntities.js';
export async function adminSampleEntities(schema, authorizationAdapter, databaseAdapter, context, query, options) {
    function getTotal(authKeys) {
        return databaseAdapter.adminEntitySearchTotalCount(schema, context, query, authKeys);
    }
    async function sampleEntities(offset, limit, authKeys) {
        const sampleResult = await databaseAdapter.adminEntitySampleEntities(schema, context, query, offset, limit, authKeys);
        if (sampleResult.isError())
            return sampleResult;
        const entities = sampleResult.value.map((it) => decodeAdminEntity(schema, it));
        return ok(entities);
    }
    return await sharedSampleEntities(authorizationAdapter, context, query, options, getTotal, sampleEntities);
}
//# sourceMappingURL=adminSampleEntities.js.map